/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webhooksGet } from "../../funcs/webhooksGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1WebhooksWebhookIdRequest$inboundSchema,
};

export const tool$webhooksGet: ToolDefinition<typeof args> = {
  name: "webhooks_get",
  description: `Get webhook

Retrieves details of a specific webhook configuration`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await webhooksGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
